import {
    BrowserRouter,
    Routes,
    Route,
    Navigate,
} from 'react-router-dom';

import AdminLogin from './pages/Admin/AdminLogin';
import ForgotPassword from "./pages/Admin/ForgotPassword";
import ResetPassword from "./pages/Admin/ResetPassword";
import AdminDashboard from "./pages/Admin/AdminDashboard";
import AdminUsers from "./pages/Admin/AdminUsers";
import AdminHomePage from "./pages/Admin/AdminHomePage";
import RangePage from "./pages/Admin/RangePage";
import AdminCuisines from "./pages/Admin/AdminCuisines";
import AdminRecipeCategories from "./pages/Admin/AdminRecipeCategory";
import AdminDifficulty from "./pages/Admin/AdminDifficulty";
import AdminOccasion from "./pages/Admin/AdminOccasion";
import AdminProtein from "./pages/Admin/AdminProtein";
import AdminTime from "./pages/Admin/AdminTimes";
import AdminDietaryPreference from "./pages/Admin/AdminDietaryPreference";
import AdminCookingMethod from "./pages/Admin/AdminCookingMethod";
import AdminRecipes from "./pages/Admin/AdminRecipes";
import AdminFanRecipes from "./pages/Admin/AdminFanRecipes";
import AdminBlogs from "./pages/Admin/AdminBlogs";
import AdminBlogCategories from "./pages/Admin/AdminBlogCategories";
import HomePage from "./pages/HomePage";
import AdminTestimonials from "./pages/Admin/AdminTestimonials";
import Products from "./pages/Products";
import Recipes from "./pages/Recipes";
import FanRecipes from "./pages/FanRecipes";
import Product from "./pages/Product";
import AdminBestServedWith from "./pages/Admin/AdminServedWith";
import ScrollToTop from "./pages/Components/ScrollToTop";
import Recipe from "./pages/Recipe";
import FanRecipe from "./pages/FanRecipe";
import Blogs from "./pages/Blogs";
import Blog from "./pages/Blog";
import AboutUs from "./pages/AboutUs";
import AdminAboutUs from "./pages/Admin/AdminAboutUs";
import AdminContactUs from "./pages/Admin/AdminContactUs";
import ContactUs from "./pages/ContactUs";
import Campaigns from "./pages/Campaigns";
import LetsCook from "./pages/LetsCook";
import CookByProduct from "./pages/CookByProduct";
import CookByCuisines from "./pages/CookByCuisines";
import AdminWhereToBuy from "./pages/Admin/AdminWhereToBuy";
import AdminLetsCook from "./pages/Admin/AdminLetsCook";
import CookClubTerms from "./pages/CookClubTerms";
import CookieBanner from "./pages/Components/CookieBanner";
import CookiePolicy from "./pages/CookiePolicy";
import Disclaimer from "./pages/Disclaimer";
import PrivacyPolicy from "./pages/PrivacyPolicy";


function App() {

    return (
        <BrowserRouter>

            <ScrollToTop />
            <CookieBanner />
            <Routes>

                <Route
                    path="/admin-login"
                    element={<AdminLogin />}
                />
                <Route path={"forgot-password"} element={<ForgotPassword />} />
                <Route path="/reset-password/:token" element={<ResetPassword />}
                />

                <Route
                    path="/admin-dashboard"
                    element={<AdminDashboard />}
                />

                <Route
                    path="/admin-users"
                    element={<AdminUsers />}
                />

                <Route
                    path="/admin-dashboard"
                    element={<AdminDashboard />}
                />
                <Route
                    path="/admin-home-page"
                    element={<AdminHomePage />}/>

                <Route
                    path="/admin-ranges"
                    element={<RangePage />} />

                <Route
                    path="/admin-cuisines"
                    element={<AdminCuisines />} />

                <Route
                    path="/admin-recipe-categories"
                    element={<AdminRecipeCategories />} />

                <Route
                    path="/admin-difficulty"
                    element={<AdminDifficulty />} />

                <Route
                    path="/admin-occasions"
                    element={<AdminOccasion />} />

                <Route
                    path="/admin-proteins"
                    element={<AdminProtein />} />

                <Route
                    path="admin-times"
                    element={<AdminTime/>} />

                <Route
                    path="admin-dietary-preferences"
                    element={<AdminDietaryPreference/>} />
                <Route
                    path="admin-cooking-methods"
                    element={<AdminCookingMethod/>} />

                <Route
                    path="admin-recipes"
                    element={<AdminRecipes />} />

                <Route
                    path="admin-fan-recipes"
                    element={<AdminFanRecipes />} />

                <Route
                    path="/admin-blog-categories"
                    element={<AdminBlogCategories />} />

                <Route
                    path="admin-blogs"
                    element={<AdminBlogs />} />

                <Route
                    path="admin-testimonials"
                    element={<AdminTestimonials />} />

                <Route path={"/admin-best-served-with"} element={<AdminBestServedWith />} />
                <Route path={"/admin-about-us"} element={<AdminAboutUs/>} />
                <Route path={"/admin-contact-us"} element={<AdminContactUs />} />
                <Route path={"/admin-where-to-buy"} element={<AdminWhereToBuy />} />
                <Route path={"/admin-lets-cook"} element={<AdminLetsCook />} />

                <Route path={"/"} element={<HomePage />} />

                <Route path="/products" element={<Products />}/>
                <Route path="/products/:slug" element={<Products />}/>
                <Route path="/product/:slug" element={<Product />} />

                <Route path="/recipes" element={<Recipes />} />
                <Route path="/recipes/:slug" element={<Recipes />} />

                <Route path="/fan-recipes" element={<FanRecipes />} />
                <Route path="/fan-recipes/:slug" element={<FanRecipes />} />

                <Route path="/recipe/:slug" element={<Recipe />} />
                <Route path="fan-recipe/:slug" element={<FanRecipe/>} />

                <Route path="/blogs" element={<Blogs />} />
                <Route path="/blogs/:slug" element={<Blogs />} />
                <Route path="/blog/:slug" element={<Blog />} />

                <Route path="/about-us" element={<AboutUs />} />
                <Route path="/contact-us" element={<ContactUs />} />
                <Route path="/campaigns" element={<Campaigns />} />
                <Route path="/lets-cook" element={<LetsCook />}/>
                <Route path="/lets-cook/by-product" element={<CookByProduct />} />
                <Route path="lets-cook/by-cuisine" element={<CookByCuisines />} />
                <Route path="/denny-cook-club-terms-conditions" element={<CookClubTerms />} />
                <Route path="cookie-policy" element={<CookiePolicy />} />
                <Route path="disclaimer" element={<Disclaimer />} />
                <Route path={"/privacy-policy"} element={<PrivacyPolicy />} />

                <Route
                    path="*"
                    element={
                        <Navigate to="/" />
                    }
                />
            </Routes>

        </BrowserRouter>
    );
}

export default App;
